/*
 * @Description: 商品流通看板
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2020-12-07 09:08:54
 * @LastEditTime: 2020-12-07 15:05:55
 */
import request from "_private/utils/request";

// 获取当日商品流通数据
export function fetchGoodsTodaySummary() {
  return request({
    url: "/coldTrace/goodsBoard/todaySummary",
    method: "get",
    headers: { type: "json" }
  });
}

// 获取商品类型流通
export function fetchGoodsTypeCirculation(params) {
  return request({
    url: "/coldTrace/goodsBoard/categoryRate",
    method: "get",
    headers: { type: "json" },
    params
  });
}

// 获取商品流通数据
export function fetchcirculationData() {
  return request({
    url: "/coldTrace/goodsBoard/circulationData",
    method: "get",
    headers: { type: "json" }
  });
}

// 获取商品流经城市
export function fetchcirculationCity() {
  return request({
    url: "/coldTrace/goodsBoard/circulationCity",
    method: "get",
    headers: { type: "json" }
  });
}
